import { call, put, takeEvery } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import axios from 'axios';
import API from '../../API';

async function postApi(data) {
    const apiUrl = API.baseURL + `/email_update_request.json`;
    try {
        const response = axios.post(apiUrl, data, API.options)
        return await response;
    } catch (error) {
        throw error;
    }
}

function* updateEmail(action) {
    try {
        const response = yield call(postApi, action.data);
        if (response.status == 200 || response.status == 201) {
            // toastr.success('Success', 'you will get a verification message');
        } else {
            // response.errors.length != 0 && toastr.error('Failed to update', response.errors[0]);
        }
        yield put({ type: 'POST_UPDATE_EMAIL_SUCCESS', data: response.data });
    } catch (e) {
        yield put({ type: 'POST_UPDATE_EMAIL_FAILED', message: e.message });
    }
}

function* updateEmailSaga() {
    yield takeEvery('POST_UPDATE_EMAIL_REQUESTED', updateEmail);
}

export default updateEmailSaga;